
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGenericLineGoingTo as ObiGenericLineGoingToElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-generic-line-going-to.js';
 
 
 

 
 export const ObiGenericLineGoingTo = createComponent({
   react: React,
   tagName: 'obi-generic-line-going-to',
   elementClass: ObiGenericLineGoingToElement,
   events: {
     
   }
  });
 
 